var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"mx-0 px-0",attrs:{"type":"info","color":_vm.color,"value":true,"outlined":"","dense":"","icon":false,"border":"top"}},[_c('span',{staticClass:"subtitle-1"},[(!_vm.$slots.default)?[_vm._v(" "+_vm._s(_vm.texto)+" ")]:_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }